// extracted by mini-css-extract-plugin
export default {"root":"NavigationLinks_root__U5xxY"};